import { z } from 'zod';
/** Boolean predicate for a v7 UUID — for use inside a `superRefine`, where the four object-schema
 * helpers in this folder (`requiredUuidString` etc.) don't fit. */
export const isValidUuidV7 = (value) => z.uuid({ version: 'v7' }).safeParse(value).success;
//# sourceMappingURL=is-valid-uuid-v7.js.map